import * as ko from "knockout";
import BaseViewModel from "../factories/base-view-model2";
import TabPage from "../factories/tab-page";
import BaoService from "../services/bao-service";
import BaoDialog from "../factories/bao-dialog";
import TabController from "../factories/tab-controller";

/**
 * Contains Frontend logic for the InlineFrameReport
 */
class InlineFrameReport extends BaseViewModel
{
    public constructor(tabPage: TabPage) {
        super(tabPage);
    }

    public InlineFrameReportId: KnockoutObservable<string> = ko.observable<string>();
    public Title: KnockoutObservable<string> = ko.observable<string>();
    public Description: KnockoutObservable<string> = ko.observable<string>();
    public URL: KnockoutObservable<string> = ko.observable<string>();

    /**
    * Tab for the relation between Mandator and InlineFrame Report
    */
    public MandatorInlineFrameReportTab: TabPage = new TabPage();
    /**
    * Tab for the relation between Role and InlineFrame Report
    */
    public RoleInlineFrameReportTab: TabPage = new TabPage();


    public init(): JQueryPromise<void> {
        let def = $.Deferred<void>();
        super.init().then(() => {
            this.initTabs().then(() => { def.resolve(); });
        });

        return def.promise();
    }

    public InitUrl(): string {
        return "InlineFrameReport/Init";
    }

    /**
    * Initializes the RoleInlineFrameReport and MandatorInlineFrameReport Tabs
    */
    public initTabs() {
        return super.InitTabController().then(() => {


            this.MandatorInlineFrameReportTab.IsClosable(false);
            this.MandatorInlineFrameReportTab.Url("MandatorInlineFrameReportTab");
            this.TabController.AddTab(this.MandatorInlineFrameReportTab);

            this.RoleInlineFrameReportTab.IsClosable(false);
            this.RoleInlineFrameReportTab.Url("RoleInlineFrameReportTab");
            this.TabController.AddTab(this.RoleInlineFrameReportTab);

            this.TabController.SelectTab(this.MandatorInlineFrameReportTab);
        });
    };

    /**
    * Validates the Title and URL mandatory fields
    */
    public CompleteCheck()
    {
        var completed: boolean = true;

        if (this.Title() === null) {
            completed = false;
        }

        if (this.URL() === null) {
            completed = false;
        }

        if (!completed) {
            var baoDialog = new BaoDialog(BaoService.Session.ApplicationName, BaoService.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
}
export default InlineFrameReport;